<template>
    <div>
        <b-form-input class="border-0 pl-2"
                      placeholder="Untitled Query"
                      size="lg"
                      type="text"
                      v-model="query.name"/>
        <b-navbar class="report-nav p-0 pl-1" toggleable="lg">
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse id="nav_dropdown_collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item-dropdown v-if="currentComponent === 'query-create' && query_id" left text="Query">
                        <b-dropdown-item @click="save()">Save</b-dropdown-item>
                        <b-dropdown-item @click="run()">Run</b-dropdown-item>
                        <b-dropdown-item @click="newQuery()">New</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item v-else @click="setCurrentComponent('query-create')">
                        Query
                    </b-nav-item>
                    <b-nav-item-dropdown left text="Visualizations">
                        <div v-if="visualizations.length > 0">
                            <b-dropdown-item
                                v-for="visualization in visualizations"
                                :key="visualization.id"
                                @click="edit('visualization',visualization.id)">
                                {{visualization.title}}
                            </b-dropdown-item>
                        </div>
                        <b-dropdown-item @click="create('visualization')">New</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown left text="Reports">
                        <div v-if="reports.length > 0">
                            <b-dropdown-item
                                v-for="report in reports"
                                :key="report.id"
                                @click="edit('report',report.id)">
                                {{report.title}}
                            </b-dropdown-item>
                        </div>
                        <b-dropdown-item @click="create('report')">New</b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item v-if="query_id" @click="setCurrentComponent('history-component')">
                        History
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
            <div class="pull-right mr-2">
            </div>
        </b-navbar>
        <hr class="mb-0">
        <div class="content-body">
            <component :is="currentComponent" :query_id="query_id" :query_data="query.data" ref="createComponent"></component>
        </div>
    </div>
</template>

<script>
    import QueryCreate from './Create.vue';
    import VisualizationIndex from './Visualizations.vue';
    import ReportIndex from './Reports.vue';
    import HistoryComponent from './History.vue';
    import { mapState } from 'vuex';
    export default {
        components: {
            QueryCreate,
            VisualizationIndex,
            ReportIndex,
            HistoryComponent
        },
        props: {
            query_id: {
                required: false
            },
            queryData: {
                type: String
            }
        },
        data() {
            return {
                
            }
        },
        computed: {
            ...mapState('queries', {
                query: 'query',
                visualizations: 'visualizations',
                reports: 'reports',
                currentComponent: 'currentComponent'
            })
        },
        created() {
            if (this.query_id) {
                this.$store.dispatch('queries/fetchVisualizations', this.query_id);
                this.$store.dispatch('queries/fetchReports', this.query_id);                
            }
        },
        beforeDestroy() {
            this.$store.dispatch('queries/setInitialStatus');
        },
        methods: {
            create(origin) {
                if (this.query_id) {
                    this.$router.push({ name: `${origin}.create`, params: { queryId: this.$store.state.queries.query.id, queryTitle: this.query.name } });
                } else{
                    this.$swal('Create a query first');
                }
            },
            edit(source, id) {
                this.$router.push({ name: `${source}.edit`, params: { [`${source}_id`]: id } });
            },
            save() {
                this.$refs.createComponent.save();
            },
            run() {
                this.$refs.createComponent.execute();
            },
            setCurrentComponent(component) {
                this.$store.commit('queries/SET_CURRENT_COMPONENT', component);
            },
            newQuery() {
                this.$store.dispatch('queries/setInitialStatus').then(() => {
                    this.$refs.createComponent.newQuery();
                });
            }
        },
        
    }
</script>


